import React from 'react';
import DepartmentOverviewTopRow from '../portal/DepartmentOverviewTopRow';
import DepartmentWhatsNewCard from '../portal/DepartmentWhatsNewCard';
import DepartmentImplementationCard from '../portal/DepartmentImplementationCard';

const FINANCE_FALLBACK_SCHEDULE_URL =
  'https://calendly.com/ianh-fm8t/finance-strategy-call?hide_gdpr_banner=1';

const FinanceAllTab = () => {
  return (
    <div>
      {/* Community · Roadmap (with current task) · Goals */}
      <DepartmentOverviewTopRow category="finance" />

      {/* What's New (left) · Implementation Hours (right) */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <DepartmentWhatsNewCard department="finance" />
        <DepartmentImplementationCard
          department="finance"
          fallbackScheduleUrl={FINANCE_FALLBACK_SCHEDULE_URL}
        />
      </div>
    </div>
  );
};

export default FinanceAllTab;
